const locale = {
  fallback: 'bg',

  getLocale() {
    return window.localStorage.getItem('_locale') || this.fallback;
  },

  setLocale(locale) {
    window.localStorage.setItem('_locale', locale);
  },
};

export default locale;